import gql from "graphql-tag";
const deleteGenoplotCalc = gql(`mutation deleteGenoplotCalc($input: Calc!) {
  deleteGenoplotCalc(input: $input) {
    user
    calculator
  }
}
`);
const modifyCalcsMutations = {
    delete: deleteGenoplotCalc,
}
export default modifyCalcsMutations;